import { createApi } from "@reduxjs/toolkit/query/react";
import { setMapping } from "./mappingsSlice";
import baseQueryWithReauth from "../../common/utils/baseQueryReauth";

import config from "../../config";
import { isEmpty } from "lodash";
const { mappings: apiPath } = config.endpoints;

const resetLayoutOnSuccess = async (arg, { dispatch, queryFulfilled }) => {
  try {
    await queryFulfilled;
    dispatch(setMapping({}));
  } catch (error) { }
}

const mappingsService = createApi({
 reducerPath: "mappingsService",
 baseQuery: baseQueryWithReauth,
 tagTypes: ["Mappings"],
 endpoints: (builder) => ({
  getMappings: builder.query({
   // note: an optional `queryFn` may be used in place of `query`
   query: (dsn) => ({ url: apiPath.getMappings(dsn)  }),
   // Pick out data and prevent nested properties in a hook or selector
   transformResponse: (response, meta, arg) => {

    if(isEmpty(response)){
      return null;
    }

    //Fixing endpoint givin an obj when single result
    return [...[response]].flat().map(({ contentOBJ, content, ...mapping}) => ({
     ...mapping,
     content: JSON.parse(content),
    }));
   },
   // Pick out errors and prevent nested properties in a hook or selector
   transformErrorResponse: (response, meta, arg) => response.status,
   providesTags: (result) =>
    // is result available?
    result
     ? // successful query
       [
        ...result.map(({ model }) => ({ type: "Mappings", id: model })),
        { type: "Mappings", id: "LIST" },
       ]
     : // an error occurred, but we still want to refetch this query when `{ type: 'Mappings', id: 'LIST' }` is invalidated
       [{ type: "Mappings", id: "LIST" }],
  }),
  postMapping: builder.mutation({
   query: ({id,  ...mapping}) => ({
    url: apiPath.postMapping(mapping.dsn),
    method: "POST",
    body: {
     ...mapping,
     content: JSON.stringify(mapping.content),
    },
   }),
   // Pick out data and prevent nested properties in a hook or selector
   transformResponse: (response, meta, arg) => response.data,
   // Pick out errors and prevent nested properties in a hook or selector
   transformErrorResponse: (response, meta, arg) => response.status,
   // Invalidates all Post-type queries providing the `LIST` id - after all, depending of the sort order,
   // that newly created post could show up in any lists.
   invalidatesTags: ["Mappings"],
   // onQueryStarted is useful for optimistic updates
   // The 2nd parameter is the destructured `MutationLifecycleApi`
   onQueryStarted: resetLayoutOnSuccess,
   // The 2nd parameter is the destructured `MutationCacheLifecycleApi`
  }),
  putMapping: builder.mutation({
   query: (mapping) => ({
    // url: apiPath.putMapping(mapping.dsn),
    url: apiPath.postMapping(mapping.dsn),
    method: "POST",
    body: {
     ...mapping,
     content: JSON.stringify(mapping.content),
    },
   }),
   onQueryStarted: resetLayoutOnSuccess,
   // Invalidates all queries that subscribe to this Mapping `id` only.
   // In this case, `getMapping` will be re-run. `getMappings` *might*  rerun, if this id was under its results.
   invalidatesTags: ["Mappings"],
   //  invalidatesTags: (result, error, { dsn }) => [
   //   { type: "Mappings", id: dsn },
   //  ],
  }),
  deleteMapping: builder.mutation({
   query: (mapping) => ({
    url: apiPath.deleteMapping(mapping.dsn),
    method: "DELETE",
   }),
   onQueryStarted: resetLayoutOnSuccess,
   // Invalidates all queries that subscribe to this Mapping `id` only.
   invalidatesTags: ["Mappings"],
  }),
 }),
});

export default mappingsService;

export const {
  useGetMappingsQuery,
  usePostMappingMutation,
  usePutMappingMutation,
  useDeleteMappingMutation
} = mappingsService;
